import { render, staticRenderFns } from "./ManageDetailDialogV2.vue?vue&type=template&id=770a8662&scoped=true"
import script from "./ManageDetailDialogV2.vue?vue&type=script&lang=js"
export * from "./ManageDetailDialogV2.vue?vue&type=script&lang=js"
import style0 from "./ManageDetailDialogV2.vue?vue&type=style&index=0&id=770a8662&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_babel-core@7.0.0-bridge.0_@babel+core@7.27._f767d633ff263e3cf51932694db5e4d0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a8662",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/front/game-platform-web/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('770a8662')) {
      api.createRecord('770a8662', component.options)
    } else {
      api.reload('770a8662', component.options)
    }
    module.hot.accept("./ManageDetailDialogV2.vue?vue&type=template&id=770a8662&scoped=true", function () {
      api.rerender('770a8662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/admin/member/components/ManageDetailDialogV2.vue"
export default component.exports